

const bolgeOptions = [
    {
        value: 1,
        text: "Marmara",
    },
    {
        value: 2,
        text: "Karadeniz",
    },
    {
        value: 3,
        text: "Ege",
    },
    {
        value: 4,
        text: "İç Anadolu",
    },
    {
        value: 5,
        text: "Doğu Anadolu",
    },
    {
        value: 6,
        text: "Akdeniz",
    },
    {
        value: 7,
        text: "Güneydoğu Anadolu",
    }
]

export default bolgeOptions